module.exports = __webpack_public_path__ + "static/media/about1.62ea4835.png";